import { TEACHER_ROUTE } from 'app/teacher/routing-constants/teacher-routing.constant';

export const DYNAMIC_GROWTH_REPORT_ROUTE = {
  name: 'dynamicgrowthreport/:activityId',
  route(classId: string, activityId: string): string[] {
    return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), 'dynamicgrowthreport', activityId];
  }
};